import { useGetReverseCoordinates } from "@/queries/useCoordinates";
import { teresinaCenter } from "@/utils/coordinates";
import { useEffect, useState } from "react";
export const useMarkerState = ({ isEdit, isFetchedInitialData, initialLatitude, initialLongitude, }) => {
    const [draggableMarker, setDraggableMarker] = useState(null);
    useEffect(() => {
        if (!isEdit) {
            setDraggableMarker({ lat: teresinaCenter.lat, lng: teresinaCenter.lng });
            return;
        }
        if (!isFetchedInitialData)
            return;
        if (!initialLatitude || !initialLongitude)
            return;
        setDraggableMarker({
            lat: Number(initialLatitude),
            lng: Number(initialLongitude),
        });
    }, [isFetchedInitialData, initialLatitude, initialLongitude, isEdit]);
    const [debouncedMarker, setDebouncedMarker] = useState(null);
    useEffect(() => {
        if (!draggableMarker)
            return;
        const timer = setTimeout(() => {
            setDebouncedMarker(draggableMarker);
        }, 1000);
        return () => clearTimeout(timer);
    }, [draggableMarker]);
    const { data: nominatimData, isLoading: nominatimIsLoading } = useGetReverseCoordinates(debouncedMarker?.lat, debouncedMarker?.lng, {
        enabled: !!debouncedMarker,
    });
    const locationSolver = nominatimData?.address.city ??
        nominatimData?.address.municipality ??
        nominatimData?.address.town ??
        nominatimData?.address.village ??
        "";
    const neighbourhoodSolver = nominatimData?.address.suburb;
    const handleLocation = nominatimIsLoading
        ? "Carregando..."
        : [
            [nominatimData?.address.suburb, locationSolver]
                .filter(Boolean)
                .join(", "),
            nominatimData?.address.state,
        ]
            .filter(Boolean)
            .join(" - ");
    return {
        draggableMarker,
        setDraggableMarker,
        handleLocation,
        locationSolver,
        neighbourhoodSolver,
    };
};
